import { graphql, useStaticQuery } from 'gatsby';
export const useProjectTypes = () => {
    const query = useStaticQuery(graphql `
      query useProjectTypesQuery {
        cosmos {
          collections {
            projectTypes: project_types {
              name
              description
              icon {
                ticket
              }
            }
          }
        }
      }
    `);
    return query.cosmos.collections;
};
